import { Maybe } from 'graphql/jsutils/Maybe';
import { ForwardRefExoticComponent, RefAttributes } from 'react';
import { UserType } from '__generated__/globalTypes';
import { ConnectedApp } from 'containers/connected_accounts/types';

export type RefHandle<T> = T extends ForwardRefExoticComponent<RefAttributes<infer T2>> ? T2 : never;

export type User = {
    approved?: Maybe<boolean>;
    availableForStylingSessions?: Maybe<boolean>;
    bio?: Maybe<string>;
    created?: Maybe<string>;
    creator?: Maybe<string>;
    email?: Maybe<string>;
    featured?: Maybe<boolean>;
    firstName?: Maybe<string>;
    id: string;
    lastName?: Maybe<string>;
    levelId?: Maybe<string>;
    phone?: Maybe<string>;
    profileImageUrl?: Maybe<string>;
    stylistExpertiseId?: Maybe<Array<Maybe<string>>>;
    updated?: Maybe<string>;
    updater?: Maybe<string>;
    userName?: Maybe<string>;
    userType: UserType;
    connectedApps?: ConnectedApp[];
    isReviewer?: Boolean;
};

export enum DynamicLayoutVersion {
    v1 = 'v1',
    v2 = 'v2',
}
